/**
 * Toggle Preparazione / Durante asta nell'header Svincolati.
 */
import { SessionPersistence } from "../services/SessionPersistence.js";

const VALID_MODES = new Set(["prep", "live"]);

/**
 * Ripristina auctionMode da storage e sincronizza stato + UI.
 */
export function restoreAuctionModeFromPersistence() {
  const mode = SessionPersistence.getAuctionMode();
  this.state.auctionMode = mode;
  this.syncAuctionModeChrome();
  this.syncAuctionModeListFilters();
}

/**
 * Imposta modalità asta, persiste e aggiorna il controllo bipolare.
 * @param {'prep'|'live'} mode
 */
export function setAuctionMode(mode) {
  if (!VALID_MODES.has(mode)) return false;
  if (this.state.auctionMode === mode) {
    this.syncAuctionModeChrome();
    return true;
  }
  SessionPersistence.setAuctionMode(mode);
  this.state.auctionMode = mode;
  this.syncAuctionModeChrome();
  this.syncAuctionModeListFilters();
  if (typeof this.syncStudioButtonsInTable === "function") {
    this.syncStudioButtonsInTable();
  }
  return true;
}

/**
 * Collega i pulsanti del toggle (idempotente).
 */
export function setupAuctionModeChrome() {
  const group = document.querySelector("[data-testid='auction-mode-toggle']");
  if (!group) return;

  if (!group.dataset.bound) {
    group.dataset.bound = "1";
    group.querySelectorAll("[data-auction-mode]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const mode = btn.dataset.auctionMode;
        if (mode === "prep" || mode === "live") {
          this.setAuctionMode(mode);
        }
      });
    });
  }

  if (this.state.auctionMode == null) {
    this.state.auctionMode = SessionPersistence.getAuctionMode();
  }
  this.syncAuctionModeChrome();
  if (typeof this.syncAuctionModeListFilters === "function") {
    this.syncAuctionModeListFilters();
  }
}

/**
 * Aggiorna aria-pressed e classe attiva sui segmenti.
 */
export function syncAuctionModeChrome() {
  const mode = this.state.auctionMode === "live" ? "live" : "prep";
  document.querySelectorAll("[data-testid='auction-mode-toggle'] [data-auction-mode]").forEach((btn) => {
    const active = btn.dataset.auctionMode === mode;
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
  });
  document.body?.classList.toggle("auction-mode-live", mode === "live");
  document.body?.classList.toggle("auction-mode-prep", mode === "prep");

  const title = document.querySelector("[data-testid='svincolati-title']");
  if (title) {
    title.textContent = mode === "live" ? "Durante asta" : "Svincolati";
  }

  this.renderRecentTakesStrip?.();
  this.syncAppShellNav?.();
}
